import axios from 'axios'
import { BASE_URL } from '@/environment/environment'

export interface PortalWebhook {
  id: string
  name: string
  direction: 'incoming' | 'outgoing'
  enabled: boolean
  allowed_ips: string[]
  target_url: string
  events: string[]
  owner_id: string
  owner_name: string
  owner_active: boolean
  created_at: string
}
export type WebhookForm = Pick<PortalWebhook, 'name' | 'direction' | 'enabled' | 'allowed_ips' | 'target_url' | 'events'>
export interface DeliveryRecord {
  id: string
  event_id: string
  event: string
  state: 'pending' | 'delivered' | 'failed' | 'cancelled'
  attempts: number
  http_status: number | null
  error_code: string
  created_at: string
}
export interface WebhookHistory {
  deliveries: DeliveryRecord[]
  requests: Array<{ key: string; employee_id: string; changed_fields: string[]; created_at: string }>
  management: Array<{ actor_id: string; action: string; changed_fields: string[]; created_at: string }>
}

export const integrationBaseUrl = `${String(BASE_URL || '').replace(/\/$/, '')}/api/integrations`
const url = `${integrationBaseUrl}/webhooks/`
export const webhooksApi = {
  async list() {
    const { data } = await axios.get<{ results: PortalWebhook[]; next: string | null }>(url)
    return data
  },
  async next(url: string) {
    return (await axios.get<{ results: PortalWebhook[]; next: string | null }>(url)).data
  },
  async capabilities() {
    return (await axios.get<{ events: Record<string, string>; configured: boolean }>(`${url}capabilities/`)).data
  },
  async create(data: WebhookForm) {
    return (await axios.post<PortalWebhook & { secret: string }>(url, data)).data
  },
  async update(id: string, data: Partial<WebhookForm>) {
    return (await axios.patch<PortalWebhook>(`${url}${id}/`, data)).data
  },
  async rotate(id: string) {
    return (await axios.post<{ secret: string }>(`${url}${id}/rotate/`)).data
  },
  async history(id: string) {
    return (await axios.get<WebhookHistory>(`${url}${id}/history/`)).data
  },
  async retry(id: string, deliveryId: string) {
    await axios.post(`${url}${id}/retry/${deliveryId}/`)
  },
}
